// extracted by mini-css-extract-plugin
module.exports = {"root":"CopyLink_root__sFME-","label":"CopyLink_label__LOBmQ","copyLinkButton":"CopyLink_copyLinkButton__1VPf6","inputAndButtonWrapper":"CopyLink_inputAndButtonWrapper__1_PU7"};